<template>
    <el-container direction="vertical" class="debts">
        <el-row class="header">
            <el-col>
                <div class="title">
                    {{ title }}
                </div>
            </el-col>
        </el-row>
        <el-row class="main">
            <el-col>
                <div v-if="debts.length">
                    <h3>Задолженность клиентов перед компанией: {{ formatFinance(debtsTotalAmount) }} руб.</h3>
                </div>
                <div class="contacts-debts-grid pt11" v-loading="loading">
                    <template v-for="(column, index) in debtColumns">
                        <div :key="'header_' + index" class="header-cell" @click="sortBy(column.field)">
                            {{ column.headerName }}
                            <template v-if="sort.field === column.field">
                                <i class="el-icon-caret-bottom" v-if="sort.order === 'asc'"></i>
                                <i class="el-icon-caret-top" v-else></i>
                            </template>
                        </div>
                    </template>
                    <template v-for="(debt, debtIndex) in debts">
                        <template v-for="(column, columnIndex) in debtColumns">
                            <div
                                :key="debtIndex+ '_'+ columnIndex"
                                :class="column.fieldClass"
                                :title="debt[column.field]"
                            >
                                <template v-if="column.field === 'deal_id'">
                                    <a :href="getDealLink(debt[column.field])" target="_blank" class="link">
                                        {{ debt[column.field] }}
                                    </a>
                                </template>
                                <template v-else-if="['budget', 'delivery_balance', 'installer_balance'].includes(column.field)">
                                    {{ formatFinance(debt[column.field]) }}
                                </template>
                                <template v-else>
                                    {{ debt[column.field] }}
                                </template>
                            </div>
                        </template>
                    </template>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import '@/assets/styles/debts.scss';
import { formatFinance } from '@/common/utilities';

export default {
    name: 'DebtsContacts',
    data() {
        return {
            title: 'Долги Клиентов',
            loading: false,
            debts: [],
            totalDebtsAmount: null,
            debtColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Клиент', field: 'contact_name', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Телефон клиента', field: 'contact_phone', fieldClass: 'grid-cell' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Статус сделки', field: 'status', fieldClass: 'grid-cell' },
                { headerName: 'Бюджет', field: 'budget', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Остаток по доставке', field: 'delivery_balance', fieldClass: 'grid-cell text-right pr10 cut-text ' },
                { headerName: 'Остаток по монтажу', field: 'installer_balance', fieldClass: 'grid-cell text-right pr10 cut-text ' }
            ],
            sort: {
                field: null,
                order: null
            }
        };
    },
    computed: {
        debtsTotalAmount() {
            return this.debts.reduce((sum, debt) => sum + +debt.installer_balance, 0);
        }
    },
    methods: {
        formatFinance,
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        async getDebts() {
            this.loading = true;
            try {
                this.debts = await this.$store.dispatch('debts/getContactsDealDebts');
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loading = false;
            }
        },
        sortBy(field) {
            if (Object.keys(this.sort).length && this.sort.field && this.sort.field === field) {
                this.sort.order = this.sort.order === 'desc' ? 'asc' : 'desc';
            } else {
                this.sort.field = field;
                this.sort.order = 'desc';
            }
            this.debts.sort((debt1, debt2) => {
                let a = debt1[field];
                let b = debt2[field];
                if (['measurement_date', 'installation_date'].includes(field)) {
                    a = a.split('.').reverse().join('.');
                    b = b.split('.').reverse().join('.');
                }
                if (a < b) {
                    return this.sort.order === 'desc' ? -1 : 1;
                }
                if (a > b) {
                    return this.sort.order === 'desc' ? 1 : -1;
                }
                return 0;
            });
        }
    },
    mounted() {
        this.getDebts();
    }
};
</script>
